<script lang="ts">
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"

  type Props = BaseProps & {
    label?: string
    chipRef?: HTMLDivElement | undefined
  }

  let {
    label = "",
    chipRef = $bindable(),
    class: className = "",
    ...restProps
  }: Props = $props()
</script>

<div
  class={cn(
    "select-chip h-5 rounded-sm border border-general-neutral-alpha-02 bg-interaction-tag px-1 font-small-400",
    className
  )}
  bind:this={chipRef}
  {...restProps}
>
  {label}
</div>
